import apisauce from "apisauce";

import config from "../config/";

import Store from "../reducers";

import { path } from "ramda";


// const getOrgID = ()=>{
// 	if(Store){
// 		return path(["organization", "orgID"], Store.getState());
// 	}
// 	return undefined;
// }

const create = (
	baseURL = `${config.api.host}`,
	// organization = getOrgID()
) => {
	const api = apisauce.create({
		baseURL,
		headers: {
			"Content-Type": "application/json",
			"Cache-Control": "no-cache",
			//   organization
		},
		timeout: 120000
	});
	const authen = payload => api.post(`${config.api.authen}`, payload);
	const getMe = token => api.get(`${config.api.getMe}`, {}, buildToken(token));
	const getOrganization = ({headers}) =>
		api.get(
			`${config.api.getOrganization}`,
			{},
			buildHeaders(headers)
		);
	const getOrganizationByAdmin = ({ headers }) =>
		api.get(`${config.api.getOrganizationByAdmin}`, {}, buildHeaders(headers));
	const editOrganization = ({ headers, payload }) =>
		api.patch(`${config.api.editOrganization}`, payload, buildHeaders(headers));
	const uploadOrganizationBanner = ({ headers, payload }) =>
		api.post(
			`${config.api.uploadOrganizationBanner}`,
			payload,
			buildHeaders(headers)
		);

	const getAllEmployees = ({ headers }) =>
		api.get(`${config.api.getAllEmployees}`, {}, buildHeaders(headers));
	const getEmployees = ({ headers, option }) =>
		api.get(
			`${config.api.getAllEmployees}?${option}`,
			{},
			buildHeaders(headers)
		);

	const addEmployee = ({ headers, payload }) =>
		api.post(`${config.api.addEmployee}`, payload, buildHeaders(headers));
	const editEmployee = ({ id, headers, payload }) =>
		api.patch(
			`${config.api.editEmployee}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);
	const deleteEmployee = ({ id, headers, payload }) =>
		api.post(
			`${config.api.deleteEmployee}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);
	const massDeleteEmployee = ({ headers, payload }) =>
		api.post(
			`${config.api.massDeleteEmployee}`,
			payload,
			buildHeaders(headers)
		);
	const disableEmployee = ({ id, headers, payload }) =>
		api.post(
			`${config.api.disableEmployee}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);
	const massDisableEmployee = ({ headers, payload }) =>
		api.post(
			`${config.api.massDisableEmployee}`,
			payload,
			buildHeaders(headers)
		);
	const importEmployees = ({ headers, payload }) =>
		api.post(`${config.api.importEmployees}`, payload, buildHeaders(headers));
	const changePassword = ({ headers, payload }) =>
		api.put(`${config.api.changePassword}`, payload, buildHeaders(headers));
	const deleteOrganizationCategory = ({ id, headers }) =>
		api.delete(
			`${config.api.deleteOrganizationCategory}`.replace(":id", id),
			{},
			buildHeaders(headers)
		);
	const forgotPassword = ({ payload }) =>
		api.post(`${config.api.forgotPassword}`, payload);
	const getOrganizationAppointments = ({ headers }) =>
		api.get(
			`${config.api.getOrganizationAppointments}`,
			{},
			buildHeaders(headers)
		);
	const fetchAdmin = ({ headers }) =>
		api.get(`${config.api.fetchAdmin}`, {}, buildHeaders(headers));
	const addAdmin = ({ headers, payload }) =>
		api.post(config.api.addAdmin, payload, buildHeaders(headers));
	const deleteAdmin = ({ headers, userid }) =>
		api.delete(`${config.api.deleteAdmin}${userid}`, {}, buildHeaders(headers));
	const fetchOrganizationLogs = ({ headers }) =>
		api.get(`${config.api.fetchOrganizationLogs}`, {}, buildHeaders(headers));
	const addOrganizationCategoryChoice = ({ payload, id, headers }) =>
		api.post(
			`${config.api.addOrganizationCategoryChoice}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);
	const editOrganizationCategoryChoice = ({ payload, id, headers }) =>
		api.patch(
			`${config.api.editOrganizationCategoryChoice}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);
	const sendInviteToEmployees = ({ payload, headers }) =>
		api.post(
			`${config.api.sendInviteEmailToEmployees}`,
			payload,
			buildHeaders(headers)
		);
	const sendInviteToAllEmployees = ({ payload, headers }) =>
		api.post(
			`${config.api.sendInviteEmailToAllEmployees}`,
			payload,
			buildHeaders(headers)
		);
	const sendStressTestInvite = ({ payload, headers }) =>
		api.post(
			`${config.api.sendStressTestInvite}`,
			payload,
			buildHeaders(headers)
		);
	const sendStressTestInviteToAll = ({payload, headers }) =>
		api.post(
			`${config.api.sendStressTestInviteToAll}`,
			payload,
			buildHeaders(headers)
		);
	const sendStressTestInviteToRegistered = ({payload,  headers }) =>
		api.post(
			`${config.api.sendStressTestInviteToRegistered}`,
			payload,
			buildHeaders(headers)
		);
	const sendStressTestInviteToNotRegistered = ({ payload, headers }) =>
		api.post(
			`${config.api.sendStressTestInviteToNotRegistered}`,
			payload,
			buildHeaders(headers)
		);
	const fetchStressQuestionAndAnswer = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchStressQuestionAndAnswer}`,
			payload,
			buildHeaders(headers)
		);
	const fetchStressChoice = ({ payload, headers }) =>
		api.get(`${config.api.fetchStressChoice}`, payload, buildHeaders(headers));
	const fetchStressLevel = ({ payload, headers }) =>
		api.get(`${config.api.fetchStressLevel}`, payload, buildHeaders(headers));
	const fetctStressCategory = ({ payload, headers }) =>
		api.get(
			`${config.api.fetctStressCategory}`,
			payload,
			buildHeaders(headers)
		);
	const fetchStressAge = ({ payload, headers }) =>
		api.get(`${config.api.fetchStressAge}`, payload, buildHeaders(headers));
	const fetchStressGender = ({ payload, headers }) =>
		api.get(`${config.api.fetchStressGender}`, payload, buildHeaders(headers));
	const fetchStressReturning = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchStressReturning}`,
			payload,
			buildHeaders(headers)
		);
	const fetchStressOverview = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchStressOverview}`,
			payload,
			buildHeaders(headers)
		);
	const exportStressExcel = ({ payload, headers }) =>
		api.get(`${config.api.exportStressExcel}`, payload, buildHeaders(headers));

	const fetchPeopleOverview = ({ payload, headers }) =>
		api.get(`${config.api.peopleOverview}`, payload, buildHeaders(headers));
	const fetchPeople = ({ id, payload, headers }) =>
		api.get(
			`${config.api.people}`.replace(":id", id),
			payload,
			buildHeaders(headers)
		);

	const fetchCounOverview = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounOverview}`, payload, buildHeaders(headers));
	const fetchCounGender = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounGender}`, payload, buildHeaders(headers));
	const fetchCounProvider = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounProvider}`, payload, buildHeaders(headers));
	const fetchCounPlatform = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounPlatform}`, payload, buildHeaders(headers));
	const fetchCounTopic = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounTopic}`, payload, buildHeaders(headers));
	const fetchCounAge = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounAge}`, payload, buildHeaders(headers));
	const fetchCounCategory = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounCategory}`, payload, buildHeaders(headers));
	const fetchCounReturning = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounReturning}`, payload, buildHeaders(headers));
	const fetchCounFeedback = ({ payload, headers }) =>
		api.get(`${config.api.fetchCounFeedback}`, payload, buildHeaders(headers));
	const fetchCounVisitOutcome = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchCounVisitOutcome}`,
			payload,
			buildHeaders(headers)
		);

	const fetchStressSelectByFilter = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchStressSelectByFilter}`,
			payload,
			buildHeaders(headers)
		);
	const fetchStressIndividualByFilter = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchStressIndividualByFilter}`,
			payload,
			buildHeaders(headers)
		);
	const fetchCounSelectByFilter = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchCounSelectByFilter}`,
			payload,
			buildHeaders(headers)
		);
	const fetchCounIndividualByFilter = ({ payload, headers }) =>
		api.get(
			`${config.api.fetchCounIndividualByFilter}`,
			payload,
			buildHeaders(headers)
		);

	const getStressFilterEmployees = ({ payload, option, headers }) =>
		api.get(
			`${config.api.getStressFilterEmployees}?${option}`,
			payload,
			buildHeaders(headers)
		);
	const getCounFilterEmployees = ({ payload, option, headers }) =>
		api.get(
			`${config.api.getCounFilterEmployees}?${option}`,
			payload,
			buildHeaders(headers)
		);

	const exportStressFilterExcel = ({ payload, headers }) =>
		api.get(
			`${config.api.exportStressFilterExcel}`,
			payload,
			buildHeaders(headers)
		);
	const exportCounFilterExcel = ({ payload, headers }) =>
		api.get(
			`${config.api.exportCounFilterExcel}`,
			payload,
			buildHeaders(headers)
		);

	return {
		authen,
		getMe,
		getOrganization,
		getOrganizationByAdmin,
		editOrganization,
		uploadOrganizationBanner,
		getAllEmployees,
		addEmployee,
		editEmployee,
		deleteEmployee,
		massDeleteEmployee,
		disableEmployee,
		massDisableEmployee,
		importEmployees,
		changePassword,
		deleteOrganizationCategory,
		forgotPassword,
		getOrganizationAppointments,
		fetchAdmin,
		addAdmin,
		deleteAdmin,
		fetchOrganizationLogs,
		addOrganizationCategoryChoice,
		editOrganizationCategoryChoice,
		sendInviteToEmployees,
		sendInviteToAllEmployees,
		sendStressTestInvite,
		sendStressTestInviteToAll,
		sendStressTestInviteToRegistered,
		sendStressTestInviteToNotRegistered,
		getEmployees,

		fetchStressQuestionAndAnswer,
		fetchStressChoice,
		fetchStressLevel,
		fetctStressCategory,
		fetchStressAge,
		fetchStressGender,
		fetchStressReturning,
		fetchStressOverview,
		exportStressExcel,

		fetchPeopleOverview,
		fetchPeople,

		fetchCounOverview,
		fetchCounGender,
		fetchCounProvider,
		fetchCounPlatform,
		fetchCounTopic,
		fetchCounAge,
		fetchCounCategory,
		fetchCounReturning,
		fetchCounVisitOutcome,
		fetchCounFeedback,

		fetchStressSelectByFilter,
		fetchStressIndividualByFilter,
		fetchCounSelectByFilter,
		fetchCounIndividualByFilter,

		getStressFilterEmployees,
		getCounFilterEmployees,

		exportStressFilterExcel,
		exportCounFilterExcel
	};
};

export default {
	create,

};
const buildHeaders = (packHeader) =>{
	const { token, organization } = packHeader;
	let headers = { authorization: `Bearer ${token}` };
	if(organization){
		headers = {...headers, organization: organization};
	}
	// console.log("output headers: ", headers);
	return { headers };
};
const buildToken = (token) => ({ headers: { authorization: `Bearer ${token}` } });
// const buildHeaders = (token, organization_id) => ({ headers: { authorization: `Bearer ${token}` , organization :  organization_id } });



// WEBPACK FOOTER //
// ./src/services/ApiSauce.js